module.exports = __webpack_public_path__ + "img/arrow.c0d574d3.svg";